// export class IframeInjector {
//   private container: HTMLElement | null;
//   private iframe: HTMLIFrameElement;
//   private iframeSrc: string;
//   private iframeWidth: string;
//   private iframeHeight: string;
//   private loader: HTMLElement | null;

//   constructor(containerSelector: string, iframeSrc: string, iframeWidth = '100%', iframeHeight = '600px') {
//     this.container = document.getElementById(containerSelector);
//     this.loader = document.createElement('div');
//     this.loader.classList.add('loader');
//     if (this.container) {
//       this.container.style.height = iframeHeight;
//     }
//     this.iframeSrc = iframeSrc;
//     this.iframeWidth = iframeWidth;
//     this.iframeHeight = iframeHeight;

//     if (!this.container) {
//       console.error(`Container element with selector '${containerSelector}' not found.`);
//       return;
//     }

//     this.injectIframe();
//     this.applyStyles();
//   }

//   private applyStyles(): void {
//     const componentStyles = `
//       .loader {
//         border: 5px solid #ccc;
//         border-radius: 50%;
//         border-top: 5px solid #8b0000;
//         width: 50px;
//         height: 50px;
//         animation: spin 1s linear infinite;
//         left: 50%;
//         position: absolute;
//         top: 50%;
//         transform: translate(-50%, -50%);
//       }

//       /* Safari */
//       @-webkit-keyframes spin {
//         0% { -webkit-transform: rotate(0deg); }
//         100% { -webkit-transform: rotate(360deg); }
//       }

//       @keyframes spin {
//         0% { transform: rotate(0deg); }
//         100% { transform: rotate(360deg); }
//       }
//     `;

//     const styleElement = document.createElement('style');
//     styleElement.textContent = componentStyles;
//     document.head.appendChild(styleElement);
//   }

//   private injectIframe(): void {
//     // Get the current URL parameters
//     const urlParams = new URLSearchParams(window.location.search);

//     // Append UTM parameters from the client web app URL to the iframe URL
//     const utmParams = ['Utm_ClickId', 'utm_source', 'utm_ad', 'utm_adset', 'utm_campaign'];
//     utmParams.forEach((param) => {
//       const paramValue = urlParams.get(param);
//       if (paramValue) {
//         this.iframeSrc += (this.iframeSrc.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(paramValue)}`;
//       }
//     });

//     // Check if an iframe with the same source already exists in the container
//     const existingIframe = this.container?.querySelector(`iframe[src="${this.iframeSrc}"]`);

//     if (existingIframe) {
//       console.warn('Iframe with the same source already exists. Skipping injection.');
//       return;
//     }

//     // Create a new iframe element
//     this.iframe = document.createElement('iframe');

//     // Set the iframe source, width, and height
//     this.iframe.src = this.iframeSrc;
//     this.iframe.width = this.iframeWidth;
//     this.iframe.height = this.iframeHeight;

//     // Set styles for the iframe
//     this.iframe.style.display = 'block';
//     this.iframe.style.border = 'none';
//     this.iframe.style.margin = 'auto';
//     this.iframe.style.position = 'relative';

//     // Append the iframe to the container
//     if (this.container) {
//       this.container.appendChild(this.iframe);
//       this.container.insertBefore(this.loader, this.container.firstChild);
//     }
//   }
// }

// export class IframeInjector {
//   private container: HTMLElement | null;
//   private iframe: HTMLIFrameElement | null = null;
//   private iframeSrc: string;
//   private iframeWidth: string;
//   private iframeHeight: string;
//   private loader: HTMLElement | null;

//   constructor(containerSelector: string, iframeSrc: string, iframeWidth = '100%', iframeHeight = '600px') {
//     this.container = document.getElementById(containerSelector);
//     this.loader = document.createElement('div');
//     this.loader.classList.add('loader');
//     this.iframeSrc = iframeSrc;
//     this.iframeWidth = iframeWidth;
//     this.iframeHeight = iframeHeight;

//     if (!this.container) {
//       console.error(`Container element with selector '${containerSelector}' not found.`);
//       return;
//     }

//     this.injectIframe();
//     this.applyStyles();
//     this.setupEventListeners();
//   }

//   private applyStyles(): void {
//     const componentStyles = `
//       .loader {
//         border: 5px solid #ccc;
//         border-radius: 50%;
//         border-top: 5px solid #8b0000;
//         width: 50px;
//         height: 50px;
//         animation: spin 1s linear infinite;
//         left: 50%;
//         position: absolute;
//         top: 50%;
//         transform: translate(-50%, -50%);
//       }

//       /* Safari */
//       @-webkit-keyframes spin {
//         0% { -webkit-transform: rotate(0deg); }
//         100% { -webkit-transform: rotate(360deg); }
//       }

//       @keyframes spin {
//         0% { transform: rotate(0deg); }
//         100% { transform: rotate(360deg); }
//       }
//     `;

//     const styleElement = document.createElement('style');
//     styleElement.textContent = componentStyles;
//     document.head.appendChild(styleElement);
//   }

//   private injectIframe(): void {
//     // Remove any existing iframe
//     this.removeExistingIframe();

//     // Create a new iframe element
//     this.iframe = document.createElement('iframe');

//     // Set the iframe source, width, and height
//     this.iframe.src = this.iframeSrc;
//     this.iframe.width = this.iframeWidth;
//     this.iframe.height = this.iframeHeight;

//     // Set styles for the iframe
//     this.iframe.style.display = 'block';
//     this.iframe.style.border = 'none';
//     this.iframe.style.margin = 'auto';
//     this.iframe.style.position = 'relative';
//     this.iframe.style.visibility = 'hidden';

//     // Append the iframe to the container
//     if (this.container) {
//       this.container.appendChild(this.iframe);
//       this.container.insertBefore(this.loader, this.container.firstChild);
//     }
//   }

//   private setupEventListeners(): void {
//     window.addEventListener('message', (event) => {
//       if (event.data) {
//         switch (event.data.type) {
//           case 'iframeVisibilityChange':
//             this.handleIframeVisibility(event.data.success);
//             break;

//           default:
//             console.warn('Unhandled message type:', event.data.type);
//         }
//       }
//     });
//   }

//   private handleIframeVisibility(success: boolean): void {
//     if (success && this.iframe) {
//       this.iframe.style.visibility = 'visible';
//       this.removeLoader();
//     } else {
//       this.removeExistingIframe();
//     }
//   }

//   private removeExistingIframe(): void {
//     if (this.iframe) {
//       this.iframe.remove();
//       this.iframe = null;
//     }
//   }

//   private removeLoader(): void {
//     if (this.loader && this.loader.parentNode) {
//       this.loader.parentNode.removeChild(this.loader);
//     }
//   }
// }
export class IframeInjector {
  private iframe: HTMLIFrameElement | null = null;
  private loader: HTMLElement;
  private widgetData: {
    buttonName: string;
    iframeUrl: string;
    type: string;
    module: string;
    version: string;
    customClassName: string;
    token: string;
  };
  private clientClassName: string | null = null;

  constructor(widgetData: {
    buttonName: string;
    iframeUrl: string;
    type: string;
    module: string;
    version: string;
    customClassName: string;
    token: string;
  }) {
    this.widgetData = widgetData;
    this.loader = this.createLoader();

    this.injectClientStyle('https://widget-v1.dabadu.dev/widget/css/widget.css');
    this.applyStyles();
    this.setupEventListeners();
  }

  public render(parentElement: HTMLElement): void {
    const existingIframe = parentElement.querySelector(`#${this.widgetData.module}-in-injector`);

    if (existingIframe) {
      console.warn(`Widget already exists for ${this.widgetData.module}. Skipping render.`);
      return;
    }

    // Remove leftover loaders if script executed twice
    const existingLoader = parentElement.querySelector('.loader');
    if (existingLoader) {
      existingLoader.remove();
    }

    this.removeExistingIframe();

    this.iframe = document.createElement('iframe');

    this.iframe.src = `https://widget-v1.dabadu.dev/${this.widgetData.module}/${this.widgetData.token}?domain=${window.location.origin}&type=${this.widgetData.type}&version=${this.widgetData.version}`;

    this.iframe.width = '100%';
    this.iframe.height = '600px';
    this.iframe.className = 'dabadu-widget-iframe';
    this.iframe.id = `${this.widgetData.module}-in-injector`;
    this.iframe.name = `${this.widgetData.module}-in-injector`;

    this.iframe.style.display = 'block';
    this.iframe.style.border = 'none';
    this.iframe.style.margin = 'auto';
    this.iframe.style.position = 'relative';
    this.iframe.style.visibility = 'hidden';

    parentElement.appendChild(this.loader);
    parentElement.appendChild(this.iframe);
  }

  private createLoader(): HTMLElement {
    const loader = document.createElement('div');
    loader.classList.add('loader');
    return loader;
  }

  private applyStyles(): void {
    const componentStyles = `
      .loader {
        border: 5px solid #ccc;
        border-radius: 50%;
        border-top: 5px solid #8b0000;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
      }

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    const styleElement = document.createElement('style');
    styleElement.textContent = componentStyles;
    document.head.appendChild(styleElement);
  }

  private setupEventListeners(): void {
    window.addEventListener('message', (event) => {
      const data = event.data;

      if (!data || !data.res) return;

      const { type, res } = data;

      if (res.module !== this.widgetData.module) return;

      const closeEventType = `${this.widgetData.module}-modal-close`;
      const openEventType = `${this.widgetData.module}-modal-open-btn`;

      if (res?.auth === false && res?.type === 'button') {
        this.removeExistingIframe();
        return;
      }
      if (type === closeEventType) {
        if (this.widgetData.type === 'embed') return;

        this.handleIframeClose();
      } else if (type === openEventType) {
        this.handleIframeOpen(data);
      } else {
        console.warn('Unhandled message type:', type);
      }
    });
  }

  private handleIframeOpen(response: any): void {
    const { type, res } = response;
    const openEventType = `${this.widgetData.module}-modal-open-btn`;

    if (res.success && type === openEventType) {
      this.injectClientStyle('https://widget-v1.dabadu.dev/widget/css/widget.css');

      this.clientClassName = this.generateClientWidgetClass(res?.clientName, res?.module);
      this.setScopedClientVariables(this.clientClassName, {
        'primary-color': res?.primaryColor,
      });

      if (this.iframe) {
        this.iframe.classList.add(this.clientClassName);
        this.iframe.style.visibility = 'visible';
        this.removeLoader();
      }
    } else if (!res.success && type === openEventType) {
      this.removeExistingIframe();
    }
  }

  private handleIframeClose(): void {
    this.removeExistingIframe();
    window.postMessage({ eventType: 'widgetClosed', data: { module: this.widgetData.module } }, '*');
  }

  private removeExistingIframe(): void {
    if (this.iframe) {
      this.iframe.remove();
      this.iframe = null;
    }
    this.removeLoader();
  }

  private removeLoader(): void {
    if (this.loader && this.loader.parentNode) {
      this.loader.parentNode.removeChild(this.loader);
    }
  }

  private injectClientStyle(styleUrl: string): void {
    if (document.querySelector(`link[href="${styleUrl}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = styleUrl;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  private generateClientWidgetClass(clientName: string, widgetType: string): string {
    const safeClient = clientName
      ?.trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    const safeWidget = widgetType
      ?.trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    return `dabadu-${safeClient}-${safeWidget}`;
  }

  private setScopedClientVariables(className: string, vars: Record<string, string>): void {
    const style = document.createElement('style');
    const varDeclarations = Object.entries(vars)
      .map(([key, val]) => `--${key}: ${val};`)
      .join('\n');

    style.textContent = `
      .${className} {
        ${varDeclarations}
      }
    `;
    document.head.appendChild(style);
  }
}
